import { render } from "./PortfolioCertegy.vue?vue&type=template&id=3f28807f"
import script from "./PortfolioCertegy.vue?vue&type=script&lang=js"
export * from "./PortfolioCertegy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__